import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { CandyButton } from "../playful/CandyButton";
import { GeometricBadge } from "../playful/GeometricBadge";
import { Reveal } from "./Reveal";
import { HOME_FAQ } from "../../copy/homeFaq";

const FAQS = HOME_FAQ;

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="overflow-hidden rounded-2xl border-2 border-ink bg-white shadow-sticker-xs">
      <button
        type="button"
        className="candy-press flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="font-display text-lg font-bold leading-snug">{q}</span>
        <span
          className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-ink bg-candy-tint transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        >
          <ChevronDown size={13} strokeWidth={3} />
        </span>
      </button>
      <div
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: open ? "400px" : "0", opacity: open ? 1 : 0 }}
      >
        <p className="px-6 pb-6 pt-4 font-sans text-base leading-relaxed text-muted-foreground">
          {a}
        </p>
      </div>
    </div>
  );
}

/** FAQSection — platform-level questions. */
export default function FAQSection() {
  return (
    <section className="border-y-2 border-ink bg-white" data-testid="faq-section">
      <div className="mx-auto max-w-[1400px] px-5 py-20 md:px-10">
        <div className="flex flex-col gap-10 lg:flex-row">
          <Reveal className="w-full min-w-0 lg:w-1/3">
            <GeometricBadge tone="yellow">FAQ</GeometricBadge>
            <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tight md:text-5xl">
              Common
              <span className="ai-gradient-text"> questions.</span>
            </h2>
            <p className="mt-4 font-sans text-base leading-relaxed text-muted-foreground">
              Can't find an answer? Open a lane and ask us — we actually read the emails.
            </p>
            <div className="mt-8">
              <CandyButton href="https://docs.linklane.io" variant="paper" withArrow>
                Read the docs
              </CandyButton>
            </div>
          </Reveal>

          <Reveal delay={100} className="flex w-full min-w-0 flex-col gap-3 lg:w-2/3">
            {FAQS.map((item) => (
              <FAQItem key={item.q} q={item.q} a={item.a} />
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
